<template>
  <div @click="closeModal" class="modal" v-if="uploadModal || modal">
    <Completed
      v-if="modal"
      v-on:close-modal="modalToggle"
      v-bind:modal="modal"
    />
    <div v-if="uploadModal" class="modal-wrap">
      <div>
        <h2>Upload</h2>
        <div class="upload-file">
          <p>Attach a document?</p>
          <input v-model="isChecked" type="checkbox" />
        </div>
        <form @submit="uploadDocument" id="formUpload" action>
          <div class="input-field">
            <label for="categorys">Category</label>
            <select
              @change="getCurrentCategoryId"
              name="categorys"
              id="categorys"
            >
              <option value="0">Select Category</option>
              <option
                v-for="title in categories"
                v-bind:key="title.id"
                :value="title.id"
              >
                {{ title.name }}
              </option>
            </select>
          </div>
          <div v-if="subCategory" class="input-field">
            <label for="categorys">Category</label>
            <select
              @change="getCurrentSubCategoryId"
              name="categorys"
              id="subCategorys"
            >
              <option value="0">Select SubCategory</option>
              <option
                v-for="title in subCategorys"
                v-bind:key="title.id"
                :value="title.id"
              >
                {{ title.name }}
              </option>
            </select>
          </div>
          <div class="input-field">
            <label for="documentName">Document Name</label>
            <input v-model="documentName" type="text" id="documentName" />
          </div>
          <div class="input-field">
            <label for="documentSummary">Document Summary</label>
            <textarea
              contenteditable
              v-model="docSummary"
              name
              id="documentSummary"
              cols="30"
              rows="2"
            ></textarea>
          </div>
          <div class="input-field">
            <label for="links"
              >Links (For more then 1 link, seperate by comma ",")</label
            >
            <input v-model="docLinks" type="text" id="links" />
          </div>
          <div v-if="isChecked" class="upload">
            <input id="upload" @change="onFileChange" type="file" />
            <div v-if="isError" class="error">{{ error }}</div>
            <ProgressBar v-if="this.file" v-bind:progress="progress" />
          </div>
          <button class="btn purple">Upload Document</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { timestamp } from "../firebase/init";
import ProgressBar from "./ProgressBar";
import Completed from "./Completed";
import db from "../firebase/init";
import firebase from "firebase/app";
import "firebase/storage";
import "firebase/auth";
export default {
  name: "Upload",
  components: { ProgressBar, Completed },
  props: ["id", "uploadModal", "categories"],
  data() {
    return {
      error: "",
      isError: false,
      isChecked: false,
      fileName: "",
      documentName: "",
      categoryId: "",
      docSummary: "",
      docLinks: "",
      userid: null,
      modal: false,
      progress: null,
      uploadError: null,
      url: null,
      file: false,
      subCategoryId: null,
      subCategory: null,
      subCategorys: [],
    };
  },
  created() {
    // calling this function once the page is loaded
    this.getUserId();
  },
  watch: {
    categoryId: function () {
      this.checkForSubCategory();
    },
  },
  methods: {
    checkForSubCategory() {
      this.subCategorys = [];
      const ref = db
        .collection("subCategory")
        .where("categoryId", "==", this.categoryId);
      ref.onSnapshot(async (snap) => {
        await snap.docChanges().forEach((doc) => {
          const data = {
            id: doc.doc.id,
            name: doc.doc.data().name,
          };
          this.subCategorys.push(data);
        });
        if (this.subCategorys[0]) {
          this.subCategory = true;
        } else {
          this.subCategory = false;
        }
      });
    },

    getUserId() {
      if (firebase.auth().currentUser) {
        this.userid = firebase.auth().currentUser.uid;
      }
    },
    closeModal(e) {
      // sends a signal if the target clicked is not the modal wrap
      const modal = document.querySelector(".modal");
      if (e.target === modal) {
        if (this.uploadModal === true) {
          this.$emit("close-upload-modal");
        } else if (this.modal === true) {
          this.modal = false;
        }
      }
    },
    // toggles modal for completion of modal
    modalToggle() {
      this.modal = !this.modal;
      this.documentName = "";
      this.docSummary = "";
      this.docLinks = "";
    },

    resetForm(e) {
      e.preventDefault();
      document.getElementById("formUpload").reset();
    },
    // gets category ID, then used to created the new
    // document linking to the category
    getCurrentCategoryId(e) {
      this.categoryId = e.target.value;
      console.log(this.categoryId);
    },

    getCurrentSubCategoryId(e) {
      this.subCategoryId = e.target.value;
      console.log(this.subCategoryId);
    },

    // once a file is chose into checks to ensure it is a valid
    // file type, if not it will throw an error.
    onFileChange(e) {
      const acceptedFileTypes = [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
        "video/mp4",
      ];
      this.fileName = e.target.files[0];
      if (this.fileName && acceptedFileTypes.includes(this.fileName.type)) {
        this.error = "";
      } else {
        this.isError = true;
        this.error = "This is not a vaild file type!";
      }
    },

    async upload(
      file,
      docname,
      docid,
      userid,
      docsummary,
      doclinks,
      secondaryId
    ) {
      const storageRef = firebase.storage().ref();
      const docRef = storageRef.child(`documents/${file.name}`);
      const collectionRef = db.collection("documents");
      const ref = db.collection("category").doc(this.categoryId);
      const increment = firebase.firestore.FieldValue.increment(1);
      docRef.put(file).on(
        "state_changed",
        (snap) => {
          // setting the progress bar
          let percent = (snap.bytesTransferred / snap.totalBytes) * 100;
          this.file = true;
          this.progress = percent;
        },
        (err) => {
          // if error, throw error and set it to the data value "error"
          this.uploadError = err;
        },
        async () => {
          // once it has finshed, get URL and set it to the constant and then
          //display it to the console
          const downloadURL = await docRef.getDownloadURL();
          const createdAt = timestamp();
          // adding the document into a collection
          await collectionRef.add({
            url: downloadURL,
            createdAt: createdAt,
            type: file.type,
            name: docname,
            categoryId: docid,
            secondaryId: secondaryId,
            userid: userid,
            docSummary: docsummary,
            docLinks: doclinks,
          });
          // hides the progress bar after it finshes
          this.file = false;
          this.$emit("close-on-uploaded");
          this.documentName = null;
          this.docSummary = null;
          this.docLinks = null;
          this.modal = !this.modal;
          this.subCategory = null;
          await ref.update({
            items: increment,
          });
        }
      );
    },

    async uploadNoFile(
      docname,
      docid,
      userid,
      docsummary,
      doclinks,
      secondaryId
    ) {
      const collectionRef = db.collection("documents");
      const increment = firebase.firestore.FieldValue.increment(1);
      const ref = db.collection("category").doc(this.categoryId);
      const createdAt = await timestamp();
      collectionRef
        .add({
          createdAt: createdAt,
          name: docname,
          categoryId: docid,
          secondaryId: secondaryId,
          userid: userid,
          docSummary: docsummary,
          docLinks: doclinks,
        })
        .then(async () => {
          this.$emit("close-on-uploaded");
          this.documentName = null;
          this.docSummary = null;
          this.docLinks = null;
          this.modal = !this.modal;
          this.subCategory = null;
          await ref.update({
            items: increment,
          });
        });
    },

    async uploadDocument(e) {
      await e.preventDefault();
      if (this.isChecked) {
        await this.upload(
          this.fileName,
          this.documentName,
          this.categoryId,
          this.userid,
          this.docSummary,
          this.docLinks,
          this.subCategoryId
        );
      } else if (!this.isChecked) {
        await this.uploadNoFile(
          this.documentName,
          this.categoryId,
          this.userid,
          this.docSummary,
          this.docLinks,
          this.subCategoryId
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.479);
  top: 0;
  z-index: 99;
  height: 100%;
  width: 100%;

  .modal-wrap {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    width: 500px;
    height: auto;
    padding: 2rem;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  }
}

.container-dashboard {
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
}

.upload-file {
  align-items: center;
  display: flex;
  margin-top: 16px;
  font-size: 14px;

  input[type="checkbox"] {
    margin-left: 16px;
    margin-top: 0;
    position: relative;
    border: none;
    width: 50px;
    height: 20px;
    -webkit-appearance: none;
    background: #f1f1f1;
    outline: none;
    border-radius: 20px;
    transition: 750ms ease all;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    &:focus {
      box-shadow: none;
    }
  }

  input[type="checkbox"]:before {
    transition: 750ms ease all;
    content: "";
    position: absolute;
    background-color: #6236ff;
    width: 22px;
    height: 22px;
    border-radius: 20px;
    top: 0;
    left: 0;
    transform: scale(1.1);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  input:checked[type="checkbox"] {
    background: #6236ff;
  }

  input:checked[type="checkbox"]:before {
    background: white;
    left: 30px;
  }
}

form {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.btn {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.input-field {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
}

label {
  font-size: 12px;
  font-weight: 400;
}

input,
select,
textarea {
  background-color: white;
  font-size: 14px;
  width: 100%;
  border: none;
  border-bottom: 1px solid #979797;
  margin-top: 0.5rem;
  padding: 0.7rem 4px;
  transition: 500ms ease all;

  &:focus {
    outline: none;
    box-shadow: 0 1px 0 0 #6236ff;
    border-color: #6236ff;
  }
}
</style>
